import script from "./Page.vue?vue&type=script&lang=ts&setup=true"
export * from "./Page.vue?vue&type=script&lang=ts&setup=true"

import "./Page.vue?vue&type=style&index=0&id=a15039de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a15039de"]])

export default __exports__